import React from 'react';

import inRegions from '@segment/in-regions';

import { Container, Button } from 'common/lazy';
import { track } from 'utils/analytics';
import { Component } from 'common/helpers';
import { ExternalLink } from 'common/components';
import { Spacer } from '../Spacer';

import Modal from './Modal';

import './banner.less';

const isConsentRequired = inRegions(['CA', 'EU'])();

const options = [
  'personalization_storage',
  'ad_storage',
  'ad_user_data',
  'ad_personalization',
  'analytics_storage',
  'functionality_storage',
  'security_storage',
];

function isConsentSelected() {
  return options.some((name) => localStorage[name]);
}

export default class ConsentBanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }

  componentDidMount() {
    if (isConsentRequired && !isConsentSelected()) {
      this.setState({
        open: true,
      });
    }
  }

  onSave = () => {
    track('Privacy Prefs Updated');
    location.reload();
  };

  onAcceptClick = () => {
    for (const option of options) {
      localStorage.setItem(option, 'granted');
    }

    this.onSave();
  };

  render() {
    const { open } = this.state;

    if (!open) {
      return null;
    }

    return (
      <div {...this.getAttrs()}>
        <Container>
          <h5 className={this.getElementClass('title')}>
            How we use data on this site
          </h5>
          <Spacer size="xs" />
          <p className={this.getElementClass('body')}>
            We use cookies (and other similar technologies) to collect data to
            improve your experience on our site. By using our website, you're
            agreeing to the collection of data as described in our{' '}
            <ExternalLink
              className={this.getElementClass('link')}
              href="/cookie-policy">
              Cookie Policy
            </ExternalLink>
            . You can change your preferences at any time.
          </p>
          <Spacer size="xs" />
          <p>
            <Modal
              onSave={this.onSave}
              trigger={<Button inverted>Manage</Button>}
            />
            <Button onClick={this.onAcceptClick} inverted primary>
              OK
            </Button>
          </p>
        </Container>
      </div>
    );
  }
}
